import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import { v4 } from "uuid";

dayjs.extend(utc);
dayjs.extend(customParseFormat);

import { Button } from "src/components/shared/Button/Button";
import { ITimelineItemBase } from "src/components/shared/TimelineCalendar/timeline.types";
import { Flex } from "src/styled";

import { getCurrentTimeHHMM } from "./utils";
import VitalsInputWrapper from "./VitalsInputWrapper";

interface Props {
  groupedItems: Record<string, ITimelineItemBase[]>;
  renderInputRow: (items: ITimelineItemBase[], date: string) => JSX.Element;
  onChangeItems: ((items: ITimelineItemBase[]) => void) | undefined;
  onDeleteItems: ((id: string[]) => void) | undefined;
  disabled?: boolean;
}
const VitalsInputList = ({
  renderInputRow,
  groupedItems,
  onChangeItems,
  onDeleteItems,
  disabled,
}: Props) => {
  const handleDateChange = (newDate: Date, items: ITimelineItemBase[]) => {
    const newDateString = newDate.toLocaleDateString("sv-SE"); // Ensures "YYYY-MM-DD"

    const newItems = items.map(item => ({
      ...item,
      start: `${newDateString}T${item.start.split("T")[1]}`,
      end: `${newDateString}T${item.end.split("T")[1]}`,
    }));

    onChangeItems?.(newItems);
  };

  const handleDeleteItems = (date: string) => {
    const ids = groupedItems[date].flat().map(item => item.id);
    onDeleteItems?.(ids);
  };

  const handleAddDate = () => {
    // Get the latest date from groupedItems
    const dates = Object.keys(groupedItems).sort();
    const lastDateString = dates[dates.length - 1] ?? null;

    // Calculate the new date (next day)
    const newDate = lastDateString
      ? new Date(new Date(lastDateString).getTime() + 86400000) // Add 1 day
      : new Date(); // Default to today if no previous dates exist

    const newDateString = newDate.toISOString().split("T")[0]; // "YYYY-MM-DD"
    const newTime = getCurrentTimeHHMM();
    const newEndTime = dayjs
      .utc(`${newDateString}T${newTime}`, "YYYY-MM-DDTHH:mm")
      .add(10, "minutes")
      .format("HH:mm");

    const newItems = [...Object.values(groupedItems).flat()];
    const subResource =
      newItems.length > 0 ? newItems[0].subResource : undefined;

    newItems.push({
      id: v4(),
      start: `${newDateString}T${newTime}:00Z`,
      end: `${newDateString}T${newEndTime}:00Z`, // Corrected end time
      title: "",
      subResource,
    });

    onChangeItems?.(newItems);
  };

  const dates = Object.keys(groupedItems).sort();

  return (
    <Flex direction="column" gap={10}>
      {Object.entries(groupedItems).map(([date, items]) => (
        <VitalsInputWrapper
          key={date}
          date={date}
          allDates={dates}
          onDeleteItems={() => handleDeleteItems(date)}
          onDateChange={v => handleDateChange(v, items)}
          disabled={disabled}>
          {renderInputRow(items, date)}
        </VitalsInputWrapper>
      ))}
      {!disabled && (
        <Button
          style={{ width: 100 }}
          variant="outline"
          onClick={handleAddDate}>
          Add Date
        </Button>
      )}
    </Flex>
  );
};
export default VitalsInputList;
